import React, { useState, useLayoutEffect, useEffect } from 'react';
import CreateOrEditBallot from './components/CreateOrEditBallot'
import CreateOrEditBallotItem from './components/CreateOrEditBallotItem'
import { useIsFocused } from '@react-navigation/native';
import LoadingIndicator from '../../../components/ActivityIndicator';
import { formatUtcDate } from '../../../utils/dateUtils'
import useFetch from '../../../utils/useFetch'

const createEmptyBallot = () => ({
    title: '',
    description: '',
    ballotItems: [],
    turnoutPercentToBeValid: 25,
    majorityPercentToWin: 25,
    startDate: new Date().toISOString(),
    endDate: new Date().toISOString()
})
const createEmptyBallotItem = () => ({ choices: [] })

const BallotFormScreen = ({ navigation, route }) => {
    const isFocused = useIsFocused();
    const [ballot, setBallot] = useState(createEmptyBallot());
    const [isCreateBallotScreen, setIsCreateBallotScreen] = useState(true);
    const [showBallotItemScreen, setShowBallotItemScreen] = useState(false);
    const [ballotItem, setBallotItem] = useState(createEmptyBallotItem());
    const { get, isLoading } = useFetch()

    // This intermediary screen pops up before edit and create screens and the header looks off
    // Fix for now I guess
    useLayoutEffect(() => {
        navigation.setOptions({
            headerTitle: '',
            headerLeft: () => (null)
        });
    }, [navigation]);

    useEffect(() => {
        const controller = new AbortController();
        const signal = controller.signal;

        if (isFocused) {
            const ballotId = route.params && route.params.ballotId;
            const isCreateBallotScreen = ballotId === undefined;
            setIsCreateBallotScreen(isCreateBallotScreen);
            
            if (!isCreateBallotScreen) {
                async function getBallotsData() {
                    const response = await get(`/api/ballots/${ballotId}?showDeleted=true`);
                    setBallot(response);
                }
                getBallotsData();


            } else {
                setBallot(createEmptyBallot());
            }
        }

        return () => {
            controller.abort();
        }
    }, [route, isFocused]);


    const ballotScreen = !showBallotItemScreen;

    if (ballotScreen)
        return (
            <LoadingIndicator isLoading={isLoading}>
                <CreateOrEditBallot
                    ballot={ballot}
                    setBallot={setBallot}
                    isCreateBallotScreen={isCreateBallotScreen}
                    navigation={navigation}
                    setShowBallotItemScreen={setShowBallotItemScreen}
                    setBallotItem={setBallotItem} />
            </LoadingIndicator>
        )
    else
        return <CreateOrEditBallotItem
            ballot={ballot}
            setBallot={setBallot}
            ballotItem={ballotItem}
            navigation={navigation}
            setShowBallotItemScreen={setShowBallotItemScreen} />
}

export default BallotFormScreen;